<template>
  <div class="row center">
    <div class="col-12 col-lg-8 offset-lg-2">
      <h1 class="justify-content-center text-secondary font-weight-bold mt-5 mb-5">{{ focus.paragraphe1 ? focus.paragraphe1.titre : '' }}</h1>
      <img :src=" focus.paragraphe1 ? focus.paragraphe1.image : '' " class="img-cover w-100 lozad"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getFocus } from '../../../mixins/getFocus'

export default {
  name: 'Bareme',
  mixins: [getFocus],
  data: function () {
    return {
      focus: []
    }
  },
  async beforeMount () {
    await this.getFocus('Tolus Immo', 'Bareme')
      .then(res => {
        this.focus = res
      })
  }
}
</script>
